export const fileFormat = Object.freeze({
  text: ['txt'],
})
